export enum ChildProgressSummarySteps {
  reportingPeriod = 1,
  classroom = 2,
  ageRange = 3,
  complete = 4,
}
